import type { DeepRequired } from '../fixtures.types'

const user: DeepRequired<User> = {
  __typename: 'User',
  part_time_percentage: null,
  employment_basis: null,
  training_and_competency: null,
  id: 'TEST_ID',
  organisation_id: 'TEST_ID',
  address: null,
  authentications: [],
  cases: [],
  client_record: null,
  credentials: null,
  email_address: null,
  first_name: null,
  last_name: null,
  first_time_access: null,
  group_ids: [],
  metadata: null,
  mobile_number: null,
  organisation: null,
  phone_number: null,
  primary_role_id: null,
  role_name: null,
  status: null,
  user_firm_identifier: null,
  photo: null,
  permissions: [],
  agency_codes: [],
}

export default user
